import React from "react";
import MediaQuery from "react-responsive";
import { BreakpointProps, getBreakpointOffset } from "@app/common/responsive/breakpoints";

export const Responsive: React.FunctionComponent<BreakpointProps> = props => {
  const bp = getBreakpointOffset(props);

  return (
    <MediaQuery minWidth={bp.min} maxWidth={bp.max}>
      {props.children}
    </MediaQuery>
  );
};
